import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var GetEboxListCtrl = function (fn, er) {
	var token = sessionStorage.getItem('token')
	var ids = sessionStorage.getItem('ids')
	var config = {
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},
	};

	var data = {}

	axios
		.post(ApiConfig.url.GET_EBOX_LIST, data, config)
		.then(function (result) {
			fn(result.data, result.status)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { GetEboxListCtrl };